import React from 'react';
import { SimulationMode } from '../../types/simulation';
import { Rocket, Network } from 'lucide-react';

export interface ModeSelectorProps {
  mode: SimulationMode;
  onChange: (mode: SimulationMode) => void;
  className?: string;
}

export const ModeSelector: React.FC<ModeSelectorProps> = ({
  mode,
  onChange,
  className = '',
}) => {
  return (
    <div
      data-tour="mode-selector"
      className={`
        inline-flex flex-col gap-0.5 p-1 rounded-xl bg-slate-900/95 border border-white/10
        backdrop-blur-md shadow-sm select-none ${className}
      `}
    >
      {/* Mode 1: Auto Career Pathway */}
      <button
        type="button"
        data-tour="mode-pathway-btn"
        onClick={() => onChange('pathway')}
        className={`
          flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-[11px] font-medium
          transition-all duration-150 cursor-pointer min-h-[26px] select-none whitespace-nowrap text-left
          ${
            mode === 'pathway'
              ? 'bg-accent-emerald text-slate-950 font-semibold shadow-[0_0_8px_rgba(16,185,129,0.3)] border border-emerald-300/30'
              : 'text-text-secondary hover:text-text-primary hover:bg-white/5 border border-transparent'
          }
        `}
      >
        <Rocket className={`w-3 h-3 shrink-0 ${mode === 'pathway' ? 'text-slate-950' : 'text-accent-emerald'}`} />
        <span className="leading-tight">Шлях новачка (1–60 міс)</span>
      </button>

      {/* Mode 2: Custom Sandbox Team Builder */}
      <button
        type="button"
        data-tour="mode-sandbox-btn"
        onClick={() => onChange('sandbox')}
        className={`
          flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-[11px] font-medium
          transition-all duration-150 cursor-pointer min-h-[26px] select-none whitespace-nowrap text-left
          ${
            mode === 'sandbox'
              ? 'bg-accent-cyan text-slate-950 font-semibold shadow-[0_0_8px_rgba(6,182,212,0.3)] border border-cyan-300/30'
              : 'text-text-secondary hover:text-text-primary hover:bg-white/5 border border-transparent'
          }
        `}
      >
        <Network className={`w-3 h-3 shrink-0 ${mode === 'sandbox' ? 'text-slate-950' : 'text-cyan-400'}`} />
        <span className="leading-tight">Конструктор структури</span>
      </button>
    </div>
  );
};
